import { AlarmItem } from '@/types';
import { SeverityIcon } from './SeverityIcon';
import { SEVERITY_STRIPE_CLASS } from './severityStyles';

export interface AlarmFeedRowProps {
  alarm: AlarmItem;
}

/** One row in a short alarm feed widget (as opposed to the full Notifications list row, which is richer). */
export function AlarmFeedRow({ alarm }: AlarmFeedRowProps) {
  return (
    <div className="flex gap-3 border-b border-border py-3 last:border-b-0">
      <span className={`w-[3px] shrink-0 self-stretch rounded ${SEVERITY_STRIPE_CLASS[alarm.severity]}`} />
      <SeverityIcon severity={alarm.severity} />
      <div className="min-w-0">
        <p className="text-sm font-semibold leading-snug text-text-primary">{alarm.title}</p>
        <p className="mt-0.5 font-[var(--font-mono)] text-xs text-text-secondary">
          {alarm.source} · {alarm.occurredAt}
        </p>
      </div>
    </div>
  );
}
